<bwh-lib-step-control-bar
  [langDropdown]="true"
  [withProgress]="false"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
>
</bwh-lib-step-control-bar>

<div class="create-account text-center">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.almost_there_title' | translate }}</h1>
  </div>

  <form *ngIf="form" [formGroup]="form" (ngSubmit)="submit()" class="account-form" autocomplete="off">
    <div class="row no-gutters">
      <div class="col half">
        <span>{{ 'form.field.form_first_name' | translate }}<sup>*</sup></span>
        <input
          type="text"
          class="form-input"
          formControlName="first_name"
          [placeholder]="'form.field.enter_form_first_name' | translate"
        />
      </div>
      <div class="col half">
        <span>{{ 'form.field.form_last_name' | translate }}</span>
        <input
          type="text"
          class="form-input"
          formControlName="last_name"
          [placeholder]="'form.field.enter_form_last_name' | translate"
        />
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col full">
        <span>{{ 'global.email' | translate }}<sup>*</sup></span>
        <input
          type="email"
          class="form-input"
          formControlName="email"
          autocomplete="off"
          [placeholder]="'form.field.enter_form_email' | translate"
        />
        <div *ngIf="form.get('email').invalid && form.get('email').touched" class="error-message">
          {{ 'global.email_required' | translate }}
        </div>
        <div *ngIf="emailExists" class="error-message">
          {{ 'global.email_already_exists' | translate }}
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col half">
        <span>{{ 'global.password' | translate }}<sup>*</sup></span>
        <div class="password-field">
          <input
            [type]="hidePwd ? 'password' : 'text'"
            class="form-input"
            formControlName="password"
            autocomplete="new-password"
            [placeholder]="'global.enter_password' | translate"
          />
          <span
            class="password-toggle"
            [ngClass]="{ active: !hidePwd }"
            [inlineSVG]="'/icons/icon-eye.svg'"
            (click)="hidePwd = !hidePwd"
          ></span>
        </div>
        <div *ngIf="form.get('password').invalid && form.get('password').touched" class="error-message">
          {{ 'global.password_min_length' | translate }}
        </div>
      </div>
      <div class="col half">
        <span>{{ 'global.confirm_password' | translate }}<sup>*</sup></span>
        <div class="password-field">
          <input
            [type]="hideConfirmPwd ? 'password' : 'text'"
            class="form-input"
            formControlName="password_confirm"
            autocomplete="new-password"
            [placeholder]="'global.confirm_password' | translate"
          />
          <span
            class="password-toggle"
            [ngClass]="{ active: !hideConfirmPwd }"
            [inlineSVG]="'/icons/icon-eye.svg'"
            (click)="hideConfirmPwd = !hideConfirmPwd"
          ></span>
        </div>
        <div *ngIf="form.hasError('passwordsMismatch') && form.get('password_confirm').touched" class="error-message">
          {{ 'global.passwords_do_not_match' | translate }}
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col full">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="profile_visible" />
          <span class="checkbox-text">{{ 'global.profile_visible_label' | translate }} 👍</span>
        </label>
        <span class="checkbox-hint">{{ 'global.profile_visible_hint' | translate }}</span>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col full">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="terms" />
          <span class="checkbox-text"
            >{{ 'global.accept_terms_prefix' | translate
            }}<a
              class="terms-text"
              href="https://www.mediahuis.nl/nl/algemene-voorwaarden"
              target="_blank"
              rel="noopener noreferrer"
              >{{ 'global.terms_and_conditions_link' | translate }}</a
            >{{ 'global.accept_terms_middle' | translate
            }}<a
              class="terms-text"
              href="https://www.banenrijklimburg.nl/privacy-verklaring"
              target="_blank"
              rel="noopener noreferrer"
              >{{ 'global.privacy_cookie_link' | translate }}</a
            >{{ 'global.accept_terms_suffix' | translate }}<sup>*</sup>
          </span>
        </label>
        <div *ngIf="form.get('terms').invalid && form.get('terms').touched" class="error-message">
          {{ 'global.terms_required' | translate }}
        </div>
      </div>
    </div>

    <div *ngIf="submitError" class="error-message submit-error">
      {{ 'global.something_went_wrong' | translate }}
    </div>

    <!-- <div class="without-account">
      <a class="without-account__link" (click)="continueWithoutAccount()">
        {{ 'global.continue_without_account' | translate }}
      </a>
      <p class="without-account__warning">
        {{ 'global.continue_without_account_warning' | translate }}
      </p>
    </div> -->
  </form>

  <ul class="next-button-container">
    <li *ngIf="prevBut">
      <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
        {{ 'global.previous' | translate }}
      </button>
    </li>
    <li>
      <button class="btn w-md h-lg primary" type="button" (click)="emitClose.emit('cancelled')">
        {{ 'global.cancel' | translate }}
      </button>
    </li>
    <li>
      <button class="btn w-md h-lg secondary" type="button" [disabled]="!form.valid || submitting" (click)="submit()">
        {{ 'global.create_account_submit' | translate }}
      </button>
    </li>
  </ul>
</div>
